import React, { createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { Coffee, Users, Shuffle, Home, Globe, ArrowRight, Briefcase, Leaf, Calendar } from 'lucide-react';
export function NetworkingPage() {
  const navigate = useNavigate();
  const networkingModes = [{
    id: 'coffee',
    title: 'Coffee Break',
    description: 'Informal one-to-one meetings with people who share similar interests',
    icon: Coffee,
    count: 3
  }, {
    id: 'lunch',
    title: 'Topic Lunch',
    description: 'Themed lunches with multiple people from the same location',
    icon: Users,
    count: 2
  }, {
    id: 'random',
    title: 'Random Network',
    description: 'Random connections with other members to discover new opportunities',
    icon: Shuffle,
    count: 5
  }];
  return <div className="flex flex-col min-h-screen w-full bg-white text-black font-sans" data-id="element-2274">
      {/* Main content */}
      <div className="flex-grow bg-white pt-6 pb-20 md:pb-10" data-id="element-2275">
        <div className="max-w-6xl mx-auto px-0" data-id="element-2276">
          {/* Header */}
          <div className="mb-8" data-id="element-2277">
            <h1 className="text-2xl md:text-3xl font-light font-sharp-grotesk mb-2" data-id="element-2278">
              Networking
            </h1>
            <p className="text-gray-600" data-id="element-2279">
              Select a networking mode to see available opportunities and create
              new ones. Each mode offers a different way to connect with other
              community members.
            </p>
          </div>
          {/* Eventi widget */}
          <div className="mb-8" data-id="element-2280">
            <div onClick={() => navigate('/events')} className="bg-white border border-gray-200 rounded-lg overflow-hidden cursor-pointer hover:shadow-sm transition-shadow" data-id="element-2281">
              <div className="p-6" data-id="element-2282">
                <div className="flex items-start" data-id="element-2283">
                  <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-2284">
                    <Calendar className="w-6 h-6 text-gray-700" data-id="element-2285" />
                  </div>
                  <div className="flex-1" data-id="element-2286">
                    <h3 className="text-lg font-medium font-sharp-grotesk mb-2" data-id="element-2287">
                      Events
                    </h3>
                    <p className="text-gray-600 text-sm mb-4" data-id="element-2288">
                      Join workshops, seminars, and personalized meetings based
                      on your profile and meet members with strong matching
                    </p>
                    <div className="flex items-center justify-between" data-id="element-2289">
                      <div className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full flex items-center" data-id="element-2290">
                        <span className="mr-1" data-id="element-2291">3 recommended events</span>
                        <span className="w-2 h-2 bg-green-500 rounded-full" data-id="element-2292"></span>
                      </div>
                      <ArrowRight className="w-5 h-5 text-black" data-id="element-2293" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Networking modes grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2294">
            {networkingModes.map(mode => <div key={mode.id} onClick={() => navigate(`/networking/${mode.id}`)} className="bg-white border border-gray-200 rounded-lg overflow-hidden cursor-pointer hover:shadow-sm transition-shadow" data-id="element-2295">
                <div className="p-6" data-id="element-2296">
                  <div className="flex items-start" data-id="element-2297">
                    <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-2298">
                      {createElement(mode.icon, {
                    className: 'w-6 h-6 text-gray-700'
                  })}
                    </div>
                    <div className="flex-1" data-id="element-2299">
                      <h3 className="text-lg font-medium font-sharp-grotesk mb-2" data-id="element-2300">
                        {mode.title}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4" data-id="element-2301">
                        {mode.description}
                      </p>
                      <div className="flex items-center justify-between" data-id="element-2302">
                        <div className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full" data-id="element-2303">
                          {mode.count} opportunities
                        </div>
                        <ArrowRight className="w-5 h-5 text-black" data-id="element-2304" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile bottom navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around py-3 z-50" data-id="element-2305">
        <button onClick={() => navigate('/')} className="flex flex-col items-center" data-id="element-2306">
          <Home className="w-5 h-5 text-gray-400" data-id="element-2307" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-2308">Home</span>
        </button>
        <button onClick={() => navigate('/connections')} className="flex flex-col items-center" data-id="element-2309">
          <Users className="w-5 h-5 text-gray-400" data-id="element-2310" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-2311">Connections</span>
        </button>
        <button className="flex flex-col items-center" data-id="element-2312">
          <Globe className="w-5 h-5 text-black" data-id="element-2313" />
          <span className="text-xs mt-1 text-black" data-id="element-2314">Networking</span>
        </button>
        <button onClick={() => navigate('/collaboration')} className="flex flex-col items-center" data-id="element-2315">
          <Briefcase className="w-5 h-5 text-gray-400" data-id="element-2316" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-2317">Collaboration</span>
        </button>
        <button onClick={() => navigate('/impact')} className="flex flex-col items-center" data-id="element-2318">
          <Leaf className="w-5 h-5 text-gray-400" data-id="element-2319" />
          <span className="text-xs mt-1 text-gray-400" data-id="element-2320">Impact</span>
        </button>
      </div>
    </div>;
}
export default {
  NetworkingPage
};